import { Loading } from '@arcflight/tf-component-library';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import HistorySection from '../HistoryTable/HistorySection';
import { DashboardState } from '../../models';
import { Maintenance } from '../../models/maintenance';
import { Version } from '../../models/versions';
import { getSingleMxItem } from '../../services/apiNew';

const Panel = styled.div`
  padding-inline: 48px;
  @media (max-width: 450px) {
    padding-inline: 24px;
  }
`;
type MxItemWithVersions = Maintenance & { versions?: Version[] };

const MaintenanceItemHistoryTab: React.FC = () => {
  const {
    drawer: { drawerId },
  } = useSelector((state: DashboardState) => state);
  const [versions, setVersions] = useState<Version[]>([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let cancelled = false;
  
    if (drawerId) {
      setLoading(true);
  
      getSingleMxItem({ id: drawerId })
        .then((res) => {
          if (cancelled) return;
  
          const data = res?.data as MxItemWithVersions | undefined;
          setVersions(data?.versions ?? []);
          setLoading(false);
        })
        .catch(() => {
          if (!cancelled) {
            setLoading(false);
          }
        });
    }
  
    return () => {
      cancelled = true;
    };
  }, [drawerId]);

  if (loading) {
    return <Loading loading />;
  }

  return (
    <Panel>
      <HistorySection versions={versions} title="maintenance item" noJustification />
    </Panel>
  );
};


MaintenanceItemHistoryTab.displayName = 'MaintenanceItemHistoryTab';

export default MaintenanceItemHistoryTab;